import {Grid} from '@yandex-delivery/blocks'
import clsx from 'clsx'
import React, {useCallback, useState} from 'react'

import {default as HeaderButton} from '../header-button/HeaderButton'
import ChevronIcon from '../icons/ChevronIcon'
import {classes} from './Accordion.classes'
import {AccordionItemProps} from './Accordion.types'

export function AccordionItem({header, description, separator = true, className}: AccordionItemProps) {
  const [active, setActive] = useState(false)

  const toggleHandler = useCallback(() => {
    setActive(prevState => !prevState)
  }, [setActive])

  return (
    <Grid className={clsx(classes.root, {[classes.separator]: separator}, className)} direction="column" container>
      <Grid
        alignItems="center"
        className={classes.headerContainer}
        justify="space-between"
        onPress={toggleHandler}
        wrap="nowrap"
        container
        item
      >
        <Grid item>
          <HeaderButton className={classes.header} variant="pseudo" active transparent>
            {header}
          </HeaderButton>
        </Grid>
        <Grid item>
          <ChevronIcon className={clsx(classes.arrow, {[classes.active]: active})} />
        </Grid>
      </Grid>
      <Grid className={clsx(classes.description, {[classes.active]: active})} item>
        {description}
      </Grid>
    </Grid>
  )
}
